import { render, staticRenderFns } from "./Fab.vue?vue&type=template&id=2caf24c1"
import script from "./Fab.vue?vue&type=script&setup=true&lang=js"
export * from "./Fab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2caf24c1')) {
      api.createRecord('2caf24c1', component.options)
    } else {
      api.reload('2caf24c1', component.options)
    }
    module.hot.accept("./Fab.vue?vue&type=template&id=2caf24c1", function () {
      api.rerender('2caf24c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/buttons/Fab.vue"
export default component.exports